import { useState, useCallback, useEffect } from 'react';
import StickyHeader from '@/components/cv/StickyHeader';
import Header from '@/components/cv/Header';
import Profile from '@/components/cv/Profile';
import Experience from '@/components/cv/Experience';
import Education from '@/components/cv/Education';
import Skills from '@/components/cv/Skills';
import Projects from '@/components/cv/Projects';
import Gallery from '@/components/cv/Gallery';
import Contact from '@/components/cv/Contact';
import Footer from '@/components/cv/Footer';
import ProgressIndicator from '@/components/cv/ProgressIndicator';
import BackToTop from '@/components/cv/BackToTop';
import useCustomization from '@/hooks/useCustomization';

export type Lang = 'fr' | 'en';

const getLangFromURL = (): Lang => {
  const params = new URLSearchParams(window.location.search);
  if (params.has('en')) return 'en';
  return 'fr';
};

const Index = () => {
  const [lang, setLangState] = useState<Lang>(getLangFromURL);
  const { font, setFont, color, setColor, gradient, setGradient, density, setDensity } = useCustomization();

  const setLang = useCallback((newLang: Lang) => {
    setLangState(newLang);
    const url = new URL(window.location.href);
    url.search = newLang === 'en' ? '?en' : '?fr';
    window.history.replaceState(null, '', url.toString());
  }, []);

  // Update <html lang>, <title> and meta description dynamically
  useEffect(() => {
    document.documentElement.lang = lang;
    if (lang === 'en') {
      document.title = 'Allen Le Yaouanc — Senior Digital Solutions & UX Consultant';
      document.querySelector('meta[name="description"]')?.setAttribute('content', 'Senior digital consultant specialising in WordPress, UX/UI, conversion funnels and SEO. 15+ years of experience with SMEs and European organisations.');
    } else {
      document.title = 'Allen Le Yaouanc — Consultant Senior Solutions Digitales & UX';
      document.querySelector('meta[name="description"]')?.setAttribute('content', "Consultant digital senior spécialisé en WordPress, UX/UI, tunnels de conversion et SEO. Plus de 15 ans d'expérience auprès de PME et organisations européennes.");
    }
  }, [lang]);

  return (
    <main className="min-h-screen bg-background">
      <StickyHeader lang={lang} onLangChange={setLang} />
      <ProgressIndicator lang={lang} />
      <Header
        font={font} color={color} gradient={gradient} density={density} lang={lang}
        onFontChange={setFont} onColorChange={setColor} onGradientChange={setGradient} onDensityChange={setDensity} onLangChange={setLang}
      />
      <Profile lang={lang} />
      <Experience lang={lang} />
      <Education lang={lang} />
      <Skills lang={lang} />
      <Projects lang={lang} />
      <Gallery lang={lang} />
      <Contact lang={lang} />
      <Footer />
      <BackToTop />
    </main>
  );
};

export default Index;
